import { TabPanel } from '@mui/lab';
import { TextField } from '@mui/material';
import Box from '@mui/material/Box';

/** Espelha VENDA.vnd_obs. Mudar aqui exige mudar a coluna e a #tbVenda da PROC_VENDA_GRAVAR. */
const LIMITE = 700;

interface TabDadosAdicionaisProps {
  values: any;
  handleChange: any;
  handleBlur: any;
  duploClick?: boolean;
}

/**
 * Guia "Dados adicionais" do pedido - card [NOTA FISCAL] DADOS ADICIONAIS.
 *
 * Campo de texto livre, OPCIONAL, que o usuario preenche na venda e o sistema transporta
 * para as Informacoes Complementares da NF-e, depois dos textos obrigatorios.
 *
 * ---------------------------------------------------------------------------------------
 * ESTE CAMPO E COPIA DO QUE JA FUNCIONA, DE PROPOSITO
 *
 * [CORRIGIDO 21/09/2026] A primeira versao tinha `size='small'`, `InputLabelProps shrink`
 * e `placeholder`, e o texto digitado aparecia DESENHADO POR CIMA DA BARRA DE GUIAS. Em
 * vez de teorizar sobre qual dos tres causava, copiei a forma do multiline que ja roda
 * neste sistema ha tempos (OrdemServicoCadastro, campo Descricao): TextField com
 * multiline, rows, inputProps.maxLength e o contador dentro do helperText. Nada mais.
 *
 * Se algum dia alguem precisar de placeholder ou de campo pequeno aqui, acrescente UM de
 * cada vez e confira na tela - foi a combinacao que quebrou, nao o conceito.
 *
 * ---------------------------------------------------------------------------------------
 * O textTransform VAI NO sx, E NAO E ESTILO
 *
 * O `index.css` deste projeto aplica `text-transform: uppercase` em `input, textarea,
 * select`. Aqui o texto e DADO, nao rotulo: o card pede que va para a nota "exatamente
 * conforme registrado no pedido", e ele sai impresso no DANFE. Sem esta regra o usuario
 * digita minuscula e ve maiuscula, e conclui que o sistema alterou o texto dele.
 *
 * Pelo mesmo motivo o campo NAO usa o <Input> compartilhado: aquele forca maiusculo no
 * VALOR (onChangeMaiusculo), nao so na aparencia.
 *
 * ---------------------------------------------------------------------------------------
 * O LIMITE DE 700 E DO BANCO
 *
 * VENDA.vnd_obs e nvarchar(700). O maxLength impede o usuario de digitar o que seria
 * cortado no salvar - perder texto em silencio e pior do que nao deixar digitar.
 */
export const TabDadosAdicionais = ({
  values,
  handleChange,
  handleBlur,
  duploClick,
}: TabDadosAdicionaisProps) => {
  const texto = values?.cadastro?.observacao ?? '';

  return (
    <TabPanel value={'7'}>
      <fieldset disabled={duploClick}>
        <Box className={'grid grid-cols-12 pt-4 gap-4'}>
          <Box className={'col-span-12'}>
            <TextField
              fullWidth
              multiline
              rows={8}
              label='Observações do pedido'
              name='cadastro.observacao'
              value={texto}
              onChange={handleChange}
              onBlur={handleBlur}
              inputProps={{ maxLength: LIMITE }}
              sx={{ '& textarea': { textTransform: 'none' } }}
              helperText={
                `${String(texto).length}/${LIMITE} - este texto é impresso na nota fiscal, ` +
                'nas Informações Complementares, depois dos textos obrigatórios. ' +
                'O preenchimento é opcional.'
              }
            />
          </Box>
        </Box>
      </fieldset>
    </TabPanel>
  );
};
